import { Component, Input } from '@angular/core';
import { AssetHistoryEntry } from '@services/asset.service';
import { Modal } from 'bootstrap';

@Component({
  selector: 'app-show-asset-history',
  templateUrl: './show-asset-history.component.html',
  styleUrls: ['./show-asset-history.component.css'],
  standalone: false
})
export class ShowAssetHistoryComponent {
  @Input() public cancelText = 'Close'
  public modal: Modal
  @Input() public title = 'Modal Title'

  @Input() public history: AssetHistoryEntry[]

  public onCancel: CallableFunction

  constructor() { }


  _cancel() {
    if (this.onCancel) {
      this.onCancel()
    }

    this.modal?.hide()
  }
}
